import { DWSMConfig } from '../../masterdata/models/DWSMConfig';
import { DWSMCalculationDTO } from '../models/DWSMCalculationDTO';
import { DWSMDashboardEntry } from '../models/DWSMDashboardEntry';
import { DWSMJob } from '../models/DWSMJob';
import { OverviewTMO } from '../models/OverviewTMO';
import { UploadOverviewDTO } from '../models/UploadOverviewDTO';
import { DropdownTvgDTO } from '../dwsm-video-player/model/DropdownTvgDTO';

export interface DWSMState {
    showDWSMPopup: boolean;
    isUploading: boolean;
    uploadOverview: UploadOverviewDTO | null;
    dwsmJob?: DWSMJob | null;
    calculation: DWSMCalculationDTO | null;
    cancelUpload?: boolean;
    isRedirectingToPageOnPopUp?: boolean;
    dwsmConfig: DWSMConfig | null;
    dwsmIsLoading: boolean;
    advancedSettingsIsLoading: boolean;
    overviewTmo: OverviewTMO | null;
    activeVariantUuid: string | null;
    dwsmGlobalIsLoading: boolean;
    dwsmDashboardEntries: DWSMDashboardEntry[];
    dwsmLiteDashboardEntries: DWSMDashboardEntry[];
    dwsmTmoDashboardEntries: DWSMDashboardEntry[];
    isDwsmDashboardLoading: boolean;
    isDwsmTmoDashboardLoading: boolean;
    isDwsmLiteDashboardLoading: boolean;
    showForceCaseTypePopup: boolean;
    uploadedDWSMLiteFile?: { file: ArrayBuffer; fileName: string; description: string | undefined; key: string; version: string } | null;
    muaTVGs: DropdownTvgDTO[];
    isStartingDwsmLiteTmoProcess: boolean;
    isWaitingForDwsmLiteTmoProcess: boolean;
}

export const initialState: DWSMState = {
    showDWSMPopup: false,
    isUploading: false,
    uploadOverview: null,
    calculation: null,
    cancelUpload: false,
    isRedirectingToPageOnPopUp: false,
    dwsmConfig: null,
    dwsmIsLoading: false,
    advancedSettingsIsLoading: false,
    dwsmGlobalIsLoading: false,
    dwsmDashboardEntries: [],
    dwsmLiteDashboardEntries: [],
    dwsmTmoDashboardEntries: [],
    isDwsmDashboardLoading: false,
    isDwsmTmoDashboardLoading: false,
    isDwsmLiteDashboardLoading: false,
    overviewTmo: null,
    activeVariantUuid: null,
    showForceCaseTypePopup: false,
    muaTVGs: [],
    isStartingDwsmLiteTmoProcess: false,
    isWaitingForDwsmLiteTmoProcess: false
};

export const featureKey = 'DWSMModule';
